import { Link } from "react-router-dom"
import { useGetItemQuery, useGetItemStockListQuery, useGetItemPriceHistoryQuery } from "shared/redux/endpoints/procurementItems"
import { Drawer, StatusPill, MoneyText, DateText, EmptyState } from "procurement/design"
import { Loading } from "../../ui"
import en from "procurement/design/i18n/en"

const ItemQuickDrawer = ({ itemId, open, onClose }) => {
  const { data: item, isFetching } = useGetItemQuery(itemId, { skip: !open || !itemId })
  const { data: stock } = useGetItemStockListQuery({ itemId }, { skip: !open || !itemId })
  const { data: prices } = useGetItemPriceHistoryQuery(itemId, { skip: !open || !itemId })

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={item?.name || en.items.drawerTitle}
      footer={
        itemId && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Link to={`/procurement/items/${itemId}`} className="pc-btn pc-btn--primary pc-btn--sm">
              {en.common.openFullPage}
            </Link>
          </div>
        )
      }
    >
      {isFetching && <Loading />}
      {!isFetching && !item && <EmptyState title="Couldn't load this item" />}
      {!isFetching && item && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <StatusPill status={item.isActive ? "active" : "inactive"} />
            <span style={{ fontVariantNumeric: "tabular-nums", color: "var(--text-secondary)" }}>{item.itemCode}</span>
          </div>
          <div>
            <MoneyText value={item.standardPrice} align="left" />
            {item.uom && <span style={{ color: "var(--text-muted)", fontSize: 13 }}> / {item.uom}</span>}
          </div>
          <dl style={{ margin: 0, fontSize: 13, display: "grid", gap: 8 }}>
            <div>
              <dt style={{ color: "var(--text-muted)", fontSize: 12 }}>Default vendor</dt>
              <dd style={{ margin: 0 }}>{item.defaultVendorName || "—"}</dd>
            </div>
            <div>
              <dt style={{ color: "var(--text-muted)", fontSize: 12 }}>Group / category</dt>
              <dd style={{ margin: 0 }}>
                {item.itemGroupName || "—"}
                <div style={{ color: "var(--text-muted)" }}>{item.categoryName || "—"}</div>
              </dd>
            </div>
          </dl>
          {!!prices?.length && (
            <section>
              <h3 style={{ fontSize: 13, margin: "0 0 8px" }}>{en.items.priceHistory}</h3>
              {prices.slice(0, 5).map((p, i) => (
                <div key={p.id || i} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "6px 0", borderTop: "1px solid var(--border)" }}>
                  <DateText value={p.effectiveDate} />
                  <MoneyText value={p.price} />
                </div>
              ))}
            </section>
          )}
          {!!stock?.length && (
            <section>
              <h3 style={{ fontSize: 13, margin: "0 0 8px" }}>Stock by center</h3>
              {stock.map((s, i) => (
                <div key={`${s.item?.id}-${s.center?.id}-${i}`} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "6px 0", borderTop: "1px solid var(--border)" }}>
                  <span>{s.center?.centerName || "—"}</span>
                  <span style={{ fontVariantNumeric: "tabular-nums" }}>{s.quantityOnHand ?? "—"}</span>
                </div>
              ))}
            </section>
          )}
        </div>
      )}
    </Drawer>
  )
}

export default ItemQuickDrawer
